import React, { FunctionComponent } from 'react'

import { ArcadeIconNames, Icon, IconNames } from '../Icon'
import { DesignLanguage, useIsDesignLanguage } from '../Theme'
import { ITEM_KINDS } from './constants'
import styles from './style.module.scss'
import { ItemToastKinds } from './types'

export const ToastIcon: FunctionComponent<{ kind: ItemToastKinds; icon?: IconNames | ArcadeIconNames }> = ({ kind, icon }) => {
  const isBronteDesign = useIsDesignLanguage(DesignLanguage.Bronte)

  if (typeof icon !== 'undefined' && !isBronteDesign) {
    return (
      <div className={styles.toastIconContainer}>
        <Icon title={icon} color='Inverse' size='Medium' name={icon} />
      </div>
    )
  }

  if (isBronteDesign || kind === ITEM_KINDS.DEFAULT) {
    return null
  }

  const iconName = kind === ITEM_KINDS.SUCCESS ? 'CheckFill' : 'FailedFill'
  return (
    <div className={styles.toastIconContainer}>
      <Icon title={kind} color='Inverse' size='Medium' name={iconName} />
    </div>
  )
}
